import styled from '@emotion/styled'

export const QuestionList = styled.div`
    margin-bottom: 15px;
    margin-left: 0px;
    display: flex;
    justify-content: initial;
    flex-direction: column;
`
